module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_vm._v("Table of Contents")]), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Frontispiece")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front03"
    }
  }, [_vm._v("Other Books by Bill Hufnagle")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front04"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front05"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/front06"
    }
  }, [_vm._v("Introduction: A Tale of My Hunger for the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c0001"
    }
  }, [_vm._v("RISE AND RIDE: BREAKFAST")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c001"
    }
  }, [_vm._v("Lisa Peters's Rally Circuit Honey Nut Granola")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c002"
    }
  }, [_vm._v("Lisa's Day-Long Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("DeDe Vecchio's Sturgis Farmer's Omelet")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c004"
    }
  }, [_vm._v("Dena Sheets's Fiery Breakfast Burritos")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c005"
    }
  }, [_vm._v("Rich's Dine and Dash Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c006"
    }
  }, [_vm._v("Daria Schooler's Altered States Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c007"
    }
  }, [_vm._v("Kathy Austin's Nutty French Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c0002"
    }
  }, [_vm._v("DANGEROUS CURVES: DRINKS")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/c008"
    }
  }, [_vm._v("Biker Patriot Uncle John's Nasty Black Coffee")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jason's Burning Marys")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Josh Placa's Grandma's Wild Eggnog")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lynn Dwight's Brandy or Rum Slushy")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Michael Pagan's High-Octane Martini")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KICK-STARTERS: APPETIZERS")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diabolic Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Nutty Goat Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biker Toothpicks")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa Carline's Harley Mamma Jalapeños")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bob Karcher's Shop Snacks")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Fritters")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flamethrower Fritters")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ron Janicki's Hot Rod Sausage Roll Puffs")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ron's Mu Shu Hog")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ron's Spanish Pork Appetizer")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SPEED BUMPS: DIPS AND SALSAS")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unholy Guacamole")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jim Edwards's Hot Guacamole for Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach Speed Bump Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lynn Vandervest's Wild Fire H.O.G. Chapter Cucumber Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lynn's Wild Fire H.O.G Chapter Beer Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lynn's Wild Fire H.O.G. Chapter Liver Paste")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jahn Tiger's Full Throttle Meat Sauce and Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drunken Bean Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Linda Leffel's Hooray for the Red, White, and Blue (Dip and Chips)")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wyatt and Lourdes Fuller's \"Hot Mama's\" Cheese Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nana's Famous Horseradish Cheese Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Delight Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sherry's Sizzlin' Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Fire Tomatillo Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sally Gracia's Mama Sally's Mango Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REST AREA: BREADS")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa Peters's Banana Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Imogene's Best Ever Banana Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jalapeño Zucchini Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cage-Rattling Carrot Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa's Spinach-Feta Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beer Blaster Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dixie Rider's Southern Lace Cornbread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chipotle Cheese Cornbread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa's Sweet Potato Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOWING AHEAD: SALADS")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rumbling Ranch Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Atomic Balsamic Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sun-Dried Tomato Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Harley Honey-Mustard Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sidecar Soy-Ginger Salad Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Croutons à La Diablo")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Michael Pagan's VMD Egg Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Veggies à La Diablo")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dal Smilie's Potato, Potato, Potato Salad, A.K.A. Ger's Potato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spike's Horseradish Potato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Salad à La Diablo")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suicide Shift Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jennifer Levan's Killer Corn Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crucified Cucumber Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jane Smilie's I Don't Want a Pickle-Just a High-Performance Cucumber")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mean 3-Bean Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lourdes Fuller's Cluck Delicious Chicken Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLIPPERY PAVEMENT: SOUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greaseberg's Killer Conch Chowder")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sasha's Manhattan Biker Babe Clam Chowder")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pulsating Pumpkin Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mega Moto Mushroom Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jennifer Terry's Garden Gazpacho")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Fire Zucchini Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Leather Eggplant Chickpea Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milwaukee Proud Beer and Cheese Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONSTRUCTION ZONE: WRAPS, FAJITAS, AND MORE")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rob Tonnesen's Ortega Highway Wraps")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inferno Tacos")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Leather Tostadas")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach Corn Enchiladas")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keith Winn's Flamin' Fajitas")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vroom Vroom Mushroom Fajitas")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PASSING ZONE: PASTAS")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ron and Debbie Janicki's Softail Shrimp Fettuccine")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angelic Fra Diablo with Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ruth's Smokin' Salmon and Corn Pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Painful Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leslie Hudson's \"Perfetto\" Pesto Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beau and Vicki Pacheco's Spaghetti Carbonara")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Panhead Penne with Zucchini")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tom Lindsay's Blazin' Bowties")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cavatelli from Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After-Burner Pasta Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Mack's Taco Pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Penne with Crankcase Vodka Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ron and Debbie Janicki's Vegetable Lasagna")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Tank Thai Noodles")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Highway Pad Thai")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christine Fleissner's Garlicky Macaroni and Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matt Harrington's Sac-Aroni and Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIG WHEELS TURNING: SAVORY PIES")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kosco H-D's Chicken Potpie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Machine-Gun Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leeky Cauliflower Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christine Fleissner's Chickpea Quiche")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Painful Pesto Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exhaust Pipe Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samuel Fairchild's Pizza Pot Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leather and Chrome Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potato Potato Corn Pie, a.k.a. Misfire Quiche")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BRIDGE FREEZES BEFORE ROAD: CHILI")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wyatt Barbee's H-D Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bruce Peterson's Emergency Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Long's Western-Style Beef 'n' Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brad Peterson's Famished Biker Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Gang Racing Checkered Flag Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Out Of Time Racing's Chuck Wagon Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Neug's Black Bean and Sausage Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chile Pepper Ranch Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sasha's Chicken Crossroads Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spanky's Chuckster-Style Chicken Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dudley Perkins's Harley-Davidson's Frisco Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Martha Norris Stratman's Beastiful Buffalo Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russ and Cindy Stough's Spicy Venison and Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dale Mattingly's Bean Gumbo")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TOLL ROADS: MAIN DISHES")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crankshaft Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggplant Exhaust Pipes")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Julie Rose Kapp's the World's Best Eggplant")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Bean Loaf")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burning Bean Curd Loaf")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Marsala")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where's the Beef Stir-Fry")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HD@rt Gallery's Ez Blue Cheese Fish Fillets")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa Peters's Baked Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Art Gompper's Grilled Ginger Salmon with Mango Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris Ericsen's Red Chili Pepper Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Hudgins's Sharkin Jerk Wahoo")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rick and Lynne Singer's Crawfish Lynne")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Susan Buck's Un-Fried Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Susan's Chicken with Gravy")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jerry Brown's Greased Chicken Rims")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Louie Smith's Biker Hobo Delite")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kittie Russell's Hearty Harley Chicken Teriyaki")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Giles's Sweet-and-Sour Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pete Collins's Patio Daddyo's Fat and Screamin' Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicky Alcock's Chicken from Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Craig Thorpe's Tricked Out Turkey Madras")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dragon Fire Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa's Sloppy Joe Biscuit Cups")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Susan's Basic Meatballs")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ron Janicki's Biker's Braised Beef")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sukoshi Fahey's Goulash for the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yvonne Roberts's Poorboys")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rose Elsworth's Cube Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coot's Sauerkraut and Kielbasa")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HD@rt Gallery Jalapeño Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris File's Ragin' Cajun Pork Roast with Red Cabbage Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bill Crafton's Can't-Miss Ribs That Cook While You Ride")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Larry Langlinais's Honey-Glazed Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dan Klemencic's Brown Sugar Venison")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SERVICE ROADS: SIDE DISHES")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mama Covucci's Broccoli Casserole Italiano")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steve Piehl's Ham and Broccoli Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crushed Cauliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicane Curried Cauliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big Bob's Bodacious Baked Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angela Tlack's Spicy Baked Beans in Belgian Ale")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big Fred's Ass-Squealin' Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phoenix Joseph's Hawaiian Baked Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mean Green Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stroker Tomatoes and Redline Zucchini")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Smashed Bucket Butternut Squash")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pam Krutsch's Onion")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild One Stuffed Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa Peters's Tuna-Stuffed Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Righteous Red Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kathy Austin's Tater Tot Cheese Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa's Sweet Potato Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cabin Fever Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Screaming Yellow Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PAVEMENT ENDS: DESSERTS")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dena Sheets's Bite Me Molasses Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toll Road Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa Peters's Peanut Butter Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Panhead Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma Ressman's Polish Sugar Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Fire H.O.G. Chapter Sugar Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pearl's H-D Buttercream Frosting")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paula's Chocolate Tahini Shortbread")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Out of Time Peanut Butter Brownies")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mama Mederski's Hoggin' The Brownies")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Randy Dunn's Grandma's Raised Donuts")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stephen Schatzger's Smooth Ride Rice Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Virda and Mae's Wheelie-Popping Peach Cobbler")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deb Ballard's Strawberry Surprize")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lisa's Carrot Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Henkel's Prison Break Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giles Family Cheesecake")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kosco H-D's Tollhouse Cookie Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Die Pumpkin Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doug's Hot-Bottom Sweet Potato Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Donna Rawhouser's Peanut Butter Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leslie Hudson's to Die for Peanut Butter Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tahini Bites Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Debbie Horvath's Country Apple Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Mango Surprise Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXTRA PARTS: USEFUL LITTLE RECIPES")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angela Tlack's Damn Good BBQ Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wyatt Barbee's H-D BBQ Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iron Horseradish Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Killer Queso Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Rod Red Pepper Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ouch Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ron Janicki's Onion Marmalade")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Davida Matthews's Jammin' Jalapeno Pepper Jelly")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/c205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Davida's Tastebud Burner Jalapeño Pepper Relish")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/back03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photograph Credits")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0